import React, { useState, useCallback } from 'react';

import { TextField, IconButton } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import PropTypes from 'prop-types';

import * as S from './styles';

export function Research({ onSearch }) {
  const [search, setSearch] = useState('');

  const handleSearchTerm = useCallback(
    (key) => {
      if (key === 'Enter') onSearch(search);
    },
    [search]
  );

  return (
    <S.Wrapper>
      <input
        placeholder="Pesquisar"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        onKeyUp={(event) => handleSearchTerm(event.key)}
      />

      <IconButton size="small" onClick={() => handleSearchTerm('Enter')}>
        <Search />
      </IconButton>
    </S.Wrapper>
  );
}

Research.propTypes = {
  onSearch: PropTypes.func.isRequired,
};
